import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SummarizationStatus } from '../../../../types';
import { CloseModalOptions, SummarizationModalId } from './types';

type SummarizationState = {
    summarizationStatus: SummarizationStatus;
    summarizationModalId: SummarizationModalId | null;
    isSummarizationMailForParticipants: boolean | null;
};

const initialState: SummarizationState = {
    summarizationStatus: 'TURNED_OFF',
    summarizationModalId: null,
    isSummarizationMailForParticipants: null,
};

const summarizationSlice = createSlice({
    name: 'summarization',
    initialState,
    reducers: {
        setSummarizationStatus(state, action: PayloadAction<SummarizationStatus>) {
            state.summarizationStatus = action.payload;
        },

        setSummarizationModalId(state, action: PayloadAction<SummarizationModalId | null>) {
            state.summarizationModalId = action.payload;
        },

        setIsSummarizationMailForParticipants(state, action: PayloadAction<boolean | null>) {
            state.isSummarizationMailForParticipants = action.payload;
        },

        resetSummarizationState() {
            return initialState;
        },
    },
});

export const {
    setSummarizationStatus,
    setSummarizationModalId,
    resetSummarizationState,
    setIsSummarizationMailForParticipants,
} = summarizationSlice.actions;
export const summarizationReducer = summarizationSlice.reducer;

export const startSummarizationAction = createAction<void>('summarization/start');
export const stopSummarizationAction = createAction<void>('summarization/stop');

export const setIsSummarizationModalClosedAction = createAction<CloseModalOptions>(
    'summarization/setIsSummarizationModalConfirmed'
);

export const setIsSummarizationMailForParticipantsAction = createAction<boolean | null>(
    'summarization/setIsSummarizationMailForParticipantsAction'
);
export const showSummarizationMailRecipientToastAction = createAction(
    'summarization/showSummarizationMailRecipientToastAction'
);
export const showSummarizationNoPermissionToStartToastAction = createAction(
    'summarization/showSummarizationNoPermissionToStartToastAction'
);
